@use '../../../../styles/Colors.scss' as Colors;
@use '../../../../styles/Constants.scss' as Constants;

$var-label-width: 150px;
$var-border: 1px solid Colors.$col-greyFontLight;

.items-button-wrapper {
	display: flex;
	flex-direction: row;
	padding: Constants.$val-spacing-m;
	border-top: 1px solid black;
}

.order-row {
	padding: 0 Constants.$val-spacing-xs;
}

.select-intentory-system {
	display: flex;
	align-items: center;
	background-color: Colors.$col-design-orange5;
	padding: Constants.$val-spacing-s Constants.$val-spacing-l;
	gap: Constants.$val-spacing-l;

	&__dropdown {
		border: 1px solid Colors.$col-greyMid;
		background-color: Colors.$col-white;
		flex: 1;
		z-index: 10;
	}

	& > [class^="icon-close"] {
		color: Colors.$col-canceledRed;
		cursor: pointer;
		font-size: Constants.$val-fontSizeBig;

	}
}

.item-option {
	display: flex;
	flex-direction: column;
	align-items: center;
	gap: Constants.$val-spacing-s;
	align-items: flex-start;
	margin-left: Constants.$val-spacing-s;

	&__details {
		font-size: Constants.$val-fontSizeSmall;
		color: Colors.$col-greyFontLight;
	}
}

.add-item-button {
	padding-top: Constants.$val-spacing-m;
}

.remove-item-button {
	padding-top: Constants.$val-spacing-l;
}

.item-container {
	border-top: 1px solid black;
	padding: Constants.$val-spacing-m;
}

.item-label {
	font-weight: bold;
	font-size: Constants.$val-fontSizeBig;
}

.form-container {
	background-color: Colors.$col-greyLight;
	padding-top: Constants.$val-spacing-m;
	padding-bottom: Constants.$val-spacing-m;
	padding-right: Constants.$val-spacing-s;
	padding-left: Constants.$val-spacing-s;
}

.section-container {
	background-color: white;
	padding: Constants.$val-spacing-m;
}

.total-cost-container {
	background-color: Colors.$col-greyBackground;
	padding: Constants.$val-spacing-m;
}

.section-title {
	color: Colors.$col-grey;
	text-transform: uppercase;
	font-size: Constants.$val-fontSizeBig;
	display: flex;
	flex-direction: column;
	margin-bottom: Constants.$val-spacing-m;
}

.form-title-container {
	background-color: white;
	padding: Constants.$val-spacing-m;
	border-bottom: 1px solid Colors.$col-greyBackground;
	display: flex;
	justify-content: space-between;
}
.form-title {
	font-weight: bold;
	font-size: Constants.$val-fontSizeBig;
}

.form-button-container {
	display: flex;
	flex-direction: row;

	& > * + * {
		margin-left: Constants.$val-spacing-xs;
	}
}

.total {
	padding-top: Constants.$val-spacing-l;
	font-weight: bold;
}

.field-value {
	margin-top: Constants.$val-spacing-s;
	margin-left: Constants.$val-spacing-s;
	margin-bottom: Constants.$val-spacing-s;
}

.name-value {
	margin-top: Constants.$val-spacing-s;
	margin-left: Constants.$val-spacing-s;
	margin-bottom: Constants.$val-spacing-s;
	font-weight: bold;
	padding: Constants.$val-spacing-xs;
}

.bold {
	font-weight: bold;
}

.bold-grey {
	font-weight: bold;
	color: Colors.$col-grey;
}

.dropdown-white-background {
	background-color: Colors.$col-white;
}

.right {
	margin-left: auto;
	text-align: right;
}

.error-message {
	color: Colors.$col-canceledRed;
}

.row-value {
	display: flex;
	flex-direction: row;
	align-items: center;
}

.form {
	display: flex;
	flex-direction: column;

	&__menu-option {
		width: 100%;
		margin-left: Constants.$val-spacing-s;

		&__text {
			display: flex;

			&__name {
				flex: 1;
				display: flex;
				gap: Constants.$val-spacing-xs
			}
		}

		&__sub-text {
			color: Colors.$col-greyFontLight;
			font-size: Constants.$val-fontSizeSmall;
		}
	}
}

.order-table__status {
	width: $var-label-width;
}

.tooltip-table {
	width: 100%;
	border-collapse: separate;
  }
  
.tooltip-table th,
.tooltip-table td {
	border-bottom: $var-border;
	padding: Constants.$val-spacing-xxxs Constants.$val-spacing-xxs ;
	border-left: $var-border;
}
  
.tooltip-table th {
	text-align: left;
	border-top: $var-border;
	font-size: Constants.$val-fontSizeSmall;
}

.tooltip-table th:last-child {
	text-align: right;
	border-right: $var-border;
}
  
.tooltip-table td:last-child {
	text-align: right;
	border-right: $var-border;
}

.tooltip-table td:last-child {
	border-right: $var-border;
	border-bottom: $var-border;
}

.tooltip-table th:last-child,
.tooltip-table td:last-child {
	white-space: nowrap;
	min-width: 50px;
	width: fit-content;
}